import NavigationGroup from './NavigationGroup'
import NavigationGroupLink from './NavigationGroupLink'

export type { BaseNavigationGroupProps } from './NavigationGroup'
export type { BaseNavigationGroupLinkProps } from './NavigationGroupLink'

export default Object.assign(NavigationGroup, {
  Link: NavigationGroupLink,
})
